import { Component, inject } from '@angular/core';
import { AdminBoilerplateComponent } from "../../../../core/admin-boilerplate/feature/admin-boilerplate.component";
import { Store } from '@ngrx/store';
import { selectAdminUser } from '../../../../data-services/stores/selectors/admin.selectors';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { adminActions } from '../../../../data-services/stores/actions/admin.actions';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserComplete } from '../../../../data-services/models/account/user-complete.model';
import { AuthService } from '../../../../data-services/auth.service';

@Component({
  selector: 'app-edit',
  imports: [AdminBoilerplateComponent, CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: '../ui/edit.component.html',
  styleUrl: '../ui/edit.component.css'
})
export class AdminUsersEditComponent {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute)
  private readonly _authService = inject(AuthService)

  selectedUser$ = this._store.select(selectAdminUser(parseInt(this._route.snapshot.params['id'])))

  constructor() {
    this._store.dispatch(adminActions.getSingleUser({ userId: parseInt(this._route.snapshot.params['id']) }))
  }

  isAdmin(user:UserComplete) {
    return user.permissions?.some(x => x === 'admin')
  }

  isSuperAdmin(user: UserComplete) {
    return user.permissions?.some(x => x === 'superAdmin')
  }

  canAccessAdminFunctions() {
    return this._authService.isAdministrator();
  }
}
